/**
 * Single-source-of-truth URLs that get sprinkled across the site.
 * Update once, every CTA picks up the new destination.
 *
 * These are external Cal.com booking pages — every CTA that references
 * them MUST add `target="_blank" rel="noopener noreferrer"` so the
 * scheduler opens in a new tab and the user doesn't lose their place
 * in the marketing flow.
 */

/** Operations Consulting — paid 1-hour deep-dive ($497). */
export const CONSULTING_BOOKING_URL = 'https://cal.com/team/brandcentral/operations-consulting';

/** Free 15-minute discovery call. Low-friction top-of-funnel CTA used in
 *  the Process tail, FAQs tail, Contact panel, and Footer. */
export const CONSULTATION_15MIN_URL = 'https://cal.com/sam-qc2y6n/15min';

/** AuraOS — free 15-minute product walkthrough. Dedicated Cal.com booking
 *  type for the AI Operating Foundation so AuraOS interest is tracked separately
 *  from the generic discovery call. Used by the /auraos page CTAs, the home
 *  AuraOS band CTA, and the contact form's AuraOS booking shortcut. */
export const AIOS_WALKTHROUGH_URL = 'https://cal.com/sam-qc2y6n/15-minute-walkthrough';

/** Common attributes for safe external link opens. Spread into anchor tags
 *  alongside the href. */
export const EXTERNAL_LINK_PROPS = {
  target: '_blank' as const,
  rel: 'noopener noreferrer' as const,
};
